import React, {createRef, useState, useContext} from 'react';
import SystemContext from "../../../SystemContext";
import {Grid, Button, FormControl} from "@material-ui/core";
import {
  Form,
  Alert,
  MaskedText,
  FormMemo,
  MaskedNumber, ComboSelect
} from '../../../controls';
import Dimensions from "./DimensionsGrid"
import HistoryGrid from "./HistoryGrid"

const formatChars={
  "U": "[A-Z]",
  "A": "[A-Z0-9]",
  "a": "[A-Za-z0-9]",
  "9": "[0-9]",
  "D": "[0-9.]",
  "-": "-",
  "x": "."
}


const BookingQueueForm = (_props) => {
  const props = {
    canEdit: false,
    ..._props,
  }

  const classes = props.classes;

  const [record, setRecord] = useState(props.record);
  const [editing, setEditing] = useState(false);
  const [alert, setAlert] = useState({
    open: false,
    severity: "error",
    message: ""
  });

  // if ((props.record && !record) || (!props.record && record) || (props.record && record && props.record.awbNo !== record.awbNo) ) {
  //   setRecord(props.record);
  //   setEditing(false);
  // }

  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;
  if (eventBus) {
    eventBus.bind('BookingQueueList.rowSelected', (record)=> {
      setRecord(record);
      setEditing(false);
    });
  }

  const renderFinancialDetails = (record) => {
    return (
      <Grid container checkChildren={true} spacing={3}>
        <Grid item xs={8} checkChildren={true}>
          <MaskedText
            id="currencyCode"
            label={`Base Currency for ${record.companyName}`}
            readOnly={editing!==true}
            inputLabelProps={{shrink: true}}
            fullWidth
            mask={"x".repeat(100)}
            maskChar={""}
            alwaysShowMask={false}
            formatChars={formatChars}
          />
        </Grid>
        <Grid item xs={4} checkChildren={true}>
          <MaskedNumber
            id="rate"
            label="Customer Base Rate"
            readOnly={editing!==true}
            inputLabelProps={{shrink: true}}
            decimalScale={4}
            fixedDecimalScale={true}
            fullWidth
            prefix={record.currencyCode === "USD" ? "$ " : record.currencyCode === "GBP" ? "£ " : " €"}
          />
        </Grid>

        {/* <Grid item xs={12}/> */}
        <Grid item xs={4} checkChildren={true}>
          <MaskedNumber
            id="eurAmount"
            label="EUR Amount"
            readOnly={editing!==true}
            inputLabelProps={{shrink: true}}
            decimalScale={2}
            fixedDecimalScale={true}
            fullWidth
            prefix="€ "
          />
        </Grid>

        <Grid item xs={4} checkChildren={true}>
          <MaskedNumber
            id="usdAmount"
            label="USD Amount"
            readOnly={editing!==true}
            inputLabelProps={{shrink: true}}
            decimalScale={2}
            fixedDecimalScale={true}
            fullWidth
            prefix="$ "
          />
        </Grid>

        <Grid item xs={4} checkChildren={true}>
          <MaskedNumber
            id="gbpAmount"
            label="GBP Amount"
            readOnly={editing!==true}
            inputLabelProps={{shrink: true}}
            decimalScale={2}
            fixedDecimalScale={true}
            fullWidth
            prefix="£ "
          />
        </Grid>
        {/* <Grid item xs={12}/> */}

        <Grid item xs={4} checkChildren={true}>
          <MaskedNumber
            id="usdAmount"
            label="USD Total"
            readOnly={editing!==true}
            inputLabelProps={{shrink: true}}
            decimalScale={2}
            fixedDecimalScale={true}
            fullWidth
            prefix="$ "
            style={{fontWeight: "800"}}
          />
        </Grid>
        {/* <Grid item xs={12}/> */}
        <Grid item xs={12} checkChildren={true}>
          <FormMemo
            id="note"
            label="Notes"
            readOnly={editing!==true}
            shrink={true}
          />
        </Grid>
        {/* <Grid item xs={12}/> */}
        {props.customerBooking
          ?
            <></>
          :
            <Grid item xs={12} checkChildren={true}>
              <FormMemo
                id="financeComments"
                label="Finance Notes"
                readOnly={editing!==true}
                shrink={true}
              />
          </Grid>
        }
      </Grid>
    )
  }

  const renderSlrDetails = (record) => {
    return (
      <Grid container checkChildren={true} spacing={3}>
        <Grid item xs={12} checkChildren={true}>
          <FormMemo
            id="specialInfo"
            label="Special Information"
            readOnly={editing!==true}
            shrink={true}
          />
        </Grid>
        <Grid item xs={12} checkChildren={true}>
          <FormMemo
            id="cargoDescription"
            label="Cargo Description"
            readOnly={editing!==true}
            shrink={true}
          />
        </Grid>
        {/* <Grid item xs={12}/> */}
        <Grid item xs={12} checkChildren={true}>
          <FormMemo
            id="note"
            label="Notes"
            readOnly={editing!==true}
            shrink={true}
          />
        </Grid>
      </Grid>
    )
  }

  return (
    <div key="formContainer" style={{width: "100%", textAlign:"left"}} className={classes.bookingQueueForm}>
      <Alert
        key="alert"
        onChange={(open) => {
          setAlert({ ...alert, open })
        }}
        open={alert.open}
        severity={alert.severity}
        message={alert.message}
        timeOut={alert.timeOut || 0}
      />
      {record
        ?
          <Form key="form"
                title={(record)=>{return `${record.bookingType === "SPECIAL LOAD" ? "Special Load" : "Booking"} Details for ${record.bookingType === "SPECIAL LOAD" ? record.slrCompanyName : record.awbNo}`}}
                message=""
                open={true}
                record={record}
                formBodyStyle={{maxHeight: (props.canEdit ? `calc(100vh - ${props.height + 142}px)` : `calc(100vh - ${props.height + 94}px)`)}}
                buttonBarStyle={{width: (props.canEdit ? "calc(100% - 20px)" : "0px")}}
                buttons = {editing?
                  {
                    save:{icon: "check_circle", key: "Save", label: "Save", color: "primary", disabled: (status)=>{return status.error}},
                    cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
                  }: props.canEdit?{
                    edit: {icon: "edit", key: "Edit", label: "Edit", color: "primary"}
                  }: {}
                }

                onChange={(state) => {
                  if (state.buttonPressed === "edit" && props.canEdit) {
                    setEditing(true);
                  }
                  if (state.buttonPressed === "cancel") {
                    setEditing(false);
                    setRecord(props.record);
                  }
                  if (state.buttonPressed === "save") {
                    SystemData.toggleLoadingProgress(true);
                    const record = state.record;
                    // handleUpdateCountryPermitRequirement.mutate({
                    //   extraKeys,
                    //   record,
                    //   postSuccess: () => {
                    //     setEditing(false);
                    //     SystemData.toggleLoadingProgress(false);
                    //     setAlert({ severity: "info", open: true, message: "Record Updated", timeOut: 5 });
                    //   },
                    //   postError: (data) => {
                    //     SystemData.toggleLoadingProgress(false);
                    //     if (data.errorMessage) {
                    //       SystemData.alert("Error", `${data.errorMessage}`);
                    //     } else {
                    //       SystemData.alert("Error", `An Unexpected Error has occurred creating the trip.`);
                    //     }
                    //   }
                    // });
                  } else {
                  }
                }}
          >

            <Grid container checkChildren={true} spacing={3}>

              <Grid item xs={6} checkChildren={true}>
                <MaskedNumber
                  id="expectedPieces"
                  label="Pieces"
                  readOnly={editing!==true}
                  inputLabelProps={{shrink: true}}
                  decimalScale={0}
                  fixedDecimalScale={true}
                  fullWidth
                />
              </Grid>

              <Grid item xs={6} checkChildren={true}>
                <MaskedNumber
                  id="expectedWeightKg"
                  label="Weight"
                  readOnly={editing!==true}
                  inputLabelProps={{shrink: true}}
                  decimalScale={1}
                  fixedDecimalScale={true}
                  suffix=" kg"
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} checkChildren={true}>
                <Dimensions dimensions={record.dims} height={150}/>
              </Grid>

              <Grid item xs={6} checkChildren={true}>
                <MaskedNumber
                  id="expectedVolume"
                  label="Volume"
                  readOnly={editing!==true}
                  inputLabelProps={{shrink: true}}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  suffix=" CBM"
                  fullWidth
                />
              </Grid>
              <Grid item xs={6} checkChildren={true}>
                <MaskedNumber
                  id="expectedChargeableWeight"
                  label="Chargeable Weight"
                  readOnly={editing!==true}
                  inputLabelProps={{shrink: true}}
                  decimalScale={1}
                  fixedDecimalScale={true}
                  suffix=" KG"
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} checkChildren={true}>
                { record.bookingType !== "SPECIAL LOAD" ? renderFinancialDetails(record) : renderSlrDetails(record) }
              </Grid>

              <Grid item xs={12} checkChildren={true}>
                <HistoryGrid bookingUuid={record.bookingUuid} height={300}/>
              </Grid>

            </Grid> {/*Container*/}
          </Form>
        :
          <div style={{position: "relative", width: "100%", top: "50%", height: "30px", textAlign: "center"}}>
            <Button color={"primary"}>Select a Booking to view additional details</Button>
          </div>
      }
    </div>
  );
}

export default BookingQueueForm;
